<ion-content>

  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button (click)="close()" fill="clear" color="dark" class="ion-no-padding">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData?.dark_logo[0]"></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">

    <!-- <img src="assets/img/logo-outline.svg"> -->

    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1><b>{{data.name | caption | translate}}</b></h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-list>
          <ng-container *ngFor="let group of groupedDays;let i = index">
            <ion-item color="primary" class="accordion" (click)="accordionExpanded[i]=!accordionExpanded[i];">
              <ion-label class="day-title">
                <ng-container *ngFor="let daytitle of group.day">
                  <h2 *ngIf="group.day.length<4;else smallsize">
                    {{daytitle | translate}} &nbsp;
                  </h2>
                  <ng-template #smallsize>
                    <h5>{{daytitle | translate}} &nbsp;</h5>
                  </ng-template>
                </ng-container>
              </ion-label>
              <ion-button>
                <ion-icon slot="icon-only" name="chevron-{{accordionExpanded[i] ? 'up':'down'}}"></ion-icon>
              </ion-button>
            </ion-item>
            <ng-container *ngFor="let day of group.value">
              <ion-item lines="none" class="accordion-content" *ngIf="accordionExpanded[i]">
                <ion-label>
                  <h3>{{day.name | translate}}</h3>
                  <p>{{day.start_time }} - {{day.end_time}}</p>
                </ion-label>
              </ion-item>
            </ng-container>
          </ng-container>
        </ion-list>
      </ion-col>
    </ion-row>

  </ion-grid>
</ion-content>